import { Section, SectionHeader } from '@/components/ui/primitives';
import { useI18n } from '@/lib/i18n';

export function HowItWorks(): React.JSX.Element {
  const { t } = useI18n();

  return (
    <Section subtle>
      <SectionHeader overline={t('how.overline')} title={t('how.title')} />

      <ol className="mt-12 grid gap-8 md:grid-cols-3">
        {(['1', '2', '3'] as const).map((step) => (
          <li key={step} className="flex flex-col gap-4 border-t-2 border-border-default pr-6 pt-8">
            <span className="font-display text-display font-medium leading-none text-accent">
              0{step}
            </span>
            <h3 className="text-h3 font-semibold text-primary">{t(`how.${step}.title`)}</h3>
            <p className="text-body text-secondary">{t(`how.${step}.body`)}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
